/* Built In Imports */
import dynamic from 'next/dynamic';

/* External Imports */
import { Grid } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import MidContainer from '@Layout/MidContainer';
const MediaEmbed = dynamic(() => import('@components/Embeds/MediaEmbed'));

/**
 * Renders the AuthorVdSection Card component
 *
 * @param {object} sectionContent - Data for section
 * @param sectionContent.section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @returns {ReactElement} AuthorVdSection component
 */
const AuthorVdSection = ({ section, region, lang }) => {
    return (
      <MidContainer w="768">
        <SectionTitle titleObj={section.sectionContent?.[0]} />
            
        <Grid
          placeItems={'center'}
          templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
          mb="30px"
          gridGap="30px"
            >
          <MediaEmbed sectionContent={section.sectionContent?.[1]} />                    
          <MediaEmbed sectionContent={section.sectionContent?.[2]} />
          <MediaEmbed sectionContent={section.sectionContent?.[3]} />
          <MediaEmbed sectionContent={section.sectionContent?.[4]} />
        </Grid>
      </MidContainer>
    );
}

export default AuthorVdSection;